export default __webpack_public_path__ + "static/media/abhishek.690b86a1.jpeg";